import React from 'react';
import PropTypes from 'prop-types';
import Hint from '../hint';
import styles from './styles.less';

const Input = ({ title, description, description2, hint, children }) => (
  <div className={styles.generic_container}>
    <div className={styles.title_description}>
      <h2>{title}</h2>
      <h3>{description}</h3>
      <span>{description2}</span>
    </div>
    <div className={styles.content_hint}>
      {children}
      {!!hint && <Hint text={hint} classname="firstHint" />}
    </div>
  </div>
);

Input.propTypes = {
  children: PropTypes.any,
  title: PropTypes.string,
  hint: PropTypes.string,
  description: PropTypes.string,
  description2: PropTypes.string,
};
Input.defaultProps = {
  children: [],
  title: '',
  hint: '',
  description: '',
  description2: '',
};

export default Input;
